<template>
  <div class="spacer"></div>
  <section id="about" class="py-5 dark-section">
    <div class="container">
      <div class="row align-items-center">
        <div
            class="col-md-7 mb-md-0 text-slide-in"
            :class="{ 'text-slide-in-active': textVisible }"
        >
          <h2 class="highlight-text">Ihre Daten sind unser Handwerk</h2>
          <p class="lead mb-2">{{ companyInfo.description }}</p>
<!--          <a href="#contact" class="btn btn-primary btn-lg mt-2" @click="$router.push('/contact')">
            Kontaktieren Sie uns
            <i class="fas fa-envelope"></i>
          </a>-->
        </div>

        <div class="col-md-5 text-center">
          <img
              :src="companyInfo.image"
              alt="Company Image"
              class="img-fluid rounded-img shadow-sm"
              :class="{ 'slide-in-active': imageVisible }"
          />
        </div>
      </div>

      <div class="row text-center mt-5 equal-height-row">
        <div
            class="col-md-4 d-flex align-items-stretch slide-in-card"
            :class="{ 'slide-in-card-active': cardsVisible }"
        >
          <div class="card shadow-sm hover-card mb-4 w-100">
            <div class="card-body d-flex flex-column">
              <i class="fas fa-database icon mb-3"></i>
              <h5 class="card-title">{{ companyInfo.accessibility.title }}</h5>
              <p class="card-text">{{ companyInfo.accessibility.text }}</p>
            </div>
          </div>
        </div>
        <div
            class="col-md-4 d-flex align-items-stretch slide-in-card"
            :class="{ 'slide-in-card-active': cardsVisible }"
        >
          <div class="card shadow-sm hover-card mb-4 w-100">
            <div class="card-body d-flex flex-column">
              <i class="fas fa-user-tie icon mb-3"></i>
              <h5 class="card-title">{{ companyInfo.expertise.title }}</h5>
              <p class="card-text">{{ companyInfo.expertise.text }}</p>
            </div>
          </div>
        </div>
        <div
            class="col-md-4 d-flex align-items-stretch slide-in-card"
            :class="{ 'slide-in-card-active': cardsVisible }"
        >
          <div class="card shadow-sm hover-card mb-4 w-100">
            <div class="card-body d-flex flex-column">
              <i class="fas fa-lightbulb icon mb-3"></i>
              <h5 class="card-title">{{ companyInfo.innovation.title }}</h5>
              <p class="card-text">{{ companyInfo.innovation.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
  name: 'CompanyAboutUs',
  setup() {
    const companyInfo = ref({
      image: require('@/assets/about/theme.jpg'),
      description:
          'In der heutigen datengetriebenen Welt sind Informationen der Schlüssel zum Erfolg. Wir bieten maßgeschneiderte Lösungen, um sicherzustellen, dass Sie Ihre Daten optimal nutzen können.',
      accessibility: {
        title: 'Datenzugänglichkeit',
        text: 'Was nützen Daten, wenn sie nicht zugänglich und nutzbar sind? Wir schaffen Lösungen für Datenzugänglichkeit und helfen Ihnen, das volle Potenzial Ihrer Daten zu entfalten.',
      },
      expertise: {
        title: 'Unsere Expertise',
        text: 'Vertrauen Sie auf unsere Erfahrung und unser Fachwissen, um fundierte Entscheidungen zu treffen und Innovationen in Ihrem Unternehmen voranzutreiben.',
      },
      innovation: {
        title: 'Innovation',
        text: 'Nutzen Sie unser Know-how, um Innovationen zu fördern und neue Wege in der datengestützten Welt zu beschreiten.',
      },
    });

    const imageVisible = ref(false);
    const textVisible = ref(false);
    const cardsVisible = ref(false);

    onMounted(() => {
      setTimeout(() => {
        textVisible.value = true;
        imageVisible.value = true;
        cardsVisible.value = true;
      }, 50); // Delay to trigger the animation after the component is mounted
    });

    return { companyInfo, imageVisible, textVisible, cardsVisible };
  },
});
</script>

<style scoped lang="less">
@import '@/assets/style.less';
@import '@/assets/animations.less';

.spacer{
  height: 30px;
}

/* Bild mit abgerundeten Ecken */
.img-fluid.rounded-img {
  max-height: 350px;
  margin-top: 2rem; /* Abstand nach oben */
  object-fit: cover;
  border-radius: 30px;
  opacity: 0; /* Hidden by default */
  transition: opacity 1.5s ease-in-out; /* Longer duration and smooth easing */
}

/* Flexbox für gleiche Höhe der Boxen */
.equal-height-row {
  display: flex;
  flex-wrap: wrap;
}

.equal-height-row .col-md-4 {
  display: flex;
  flex-direction: column;
}

@media (max-width: 768px) {
  .spacer{
    height: 70px;
  }

  .equal-height-row{
    gap: 2px;
  }

  .col-md-5.text-center{
    display: none;
  }

}



</style>

